import React, { useState } from 'react';

import { Col, Modal, Row } from 'react-bootstrap';
import '../JobStageSummary.scss';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { useQuery } from '@apollo/client/react';
import { Loading } from '../../../_common/Loading/Loading';
import SearchableDropdown, { DropdownOption } from '../../../_common/SearchableDropdown/SearchableDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface StageSheetDeleteModalProps {
    showStageSheetDeleteModal: boolean;
    jobId: number;
    stageSheetBoxId: number;
    stageSheetBox: string;
    handleOnClose: () => void;
    handleOnSave: (stageSheetBoxId: number) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const StageSheetDeleteModal = ({
    showStageSheetDeleteModal,
    jobId,
    stageSheetBoxId,
    stageSheetBox,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    mutationError,
}: StageSheetDeleteModalProps): React.ReactElement => {
    const searchIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'angle-down' }} />;

    const [row, setRow] = useState<string>('');
    const [column, setColumn] = useState<string>('');
    const [level, setLevel] = useState<string>('');
    const onClickClose = () => {
        handleOnClose();
    };

    const onClickSave = () => {
        handleOnSave(stageSheetBoxId);
    };

    return (
        <Modal show={showStageSheetDeleteModal} onHide={onClickClose} dialogClassName="StageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Delete Box</div>
                    <div className="AddStageModal-Error">{mutationError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                <Col md={10}>
                    <div className="StageSheet-Delete-Header">
                        Are you sure you want to delete the box - {stageSheetBox}?
                    </div>
                </Col>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton
                    title="Continue"
                    isDisabled={(row && column && level) || (!row && !column && !level) ? false : true}
                    onClick={() => onClickSave()}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default StageSheetDeleteModal;
